(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/swedbank-express.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/swedbank-express.js');
'use strict';

const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const {
  useBankAccount
} = svs.accountservicesReact.deposit.swedbankExpress.hooks;
const {
  LoaderPanel,
  ErrorPanel
} = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents;
const {
  displayStatus
} = svs.accountservicesReact.deposit.constants.swedbankExpress;
const {
  NewCustomer
} = svs.accountservicesReact.deposit.swedbankExpress.pages.newCustomer;
const {
  BankidQrcode,
  BankidSpinner,
  BankidApp
} = svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify;
const {
  ExpressDeposit
} = svs.accountservicesReact.deposit.swedbankExpress.pages.deposit;
const {
  ChangeBank
} = svs.accountservicesReact.deposit.swedbankExpress.pages.changeBank;
const {
  ExpiredConsent
} = svs.accountservicesReact.deposit.swedbankExpress.pages.expiredConsent;
const {
  clearUrlParam
} = svs.accountservicesReact.deposit.helpers.swedbankExpressUrlHelper;

const SwedbankExpress = _ref => {
  let {
    isPlayerRegistration
  } = _ref;
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  logger.debug('SwedbankExpress main code - start, **** returnUrl: ', returnUrl);

  const {
    isLoading,
    isError,
    applicationDisplayStatus,
    accountList,
    bankName,
    bankList,
    qrCode,
    getBankAccounts,
    doConsentInitAndPoll,
    doDepositInitAndPoll,
    getBankList,
    doClearBackend,
    setReturnUrl
  } = useBankAccount();
  React.useEffect(() => {
    const aid = svs.utils.url.queryString.aid;
    const pid = svs.utils.url.queryString.pid;

    if ((returnUrl === null || returnUrl === void 0 ? void 0 : returnUrl.length) > 0) {
      setReturnUrl(returnUrl);
    }
    if (aid && aid.length > 2 || pid && pid.length > 2) {
      logger.debug("Component main code - useEffect - Coming back from BankId-app and should continue poll aid:".concat(aid, ", pid:").concat(pid));
      if (aid && aid.length > 2) {
        clearUrlParam('aid');
        doConsentInitAndPoll({
          urlAuthorizeId: aid
        });
      } else if (pid && pid.length > 2) {
        clearUrlParam('pid');
        doDepositInitAndPoll({
          urlPaymentId: pid
        });
      }
    } else {
      logger.debug('Component main code - useEffect - Async call that updates accountList or redirect to new customer/expired token');
      getBankAccounts();
    }
  }, [returnUrl]);
  return React.createElement("div", null, isLoading && React.createElement(LoaderPanel, null), isError &&
  React.createElement(ErrorPanel, null), !isLoading && !isError && React.createElement(React.Fragment, null, applicationDisplayStatus === displayStatus.LOADER && React.createElement(LoaderPanel, null), applicationDisplayStatus === displayStatus.NEW_CUSTOMER && React.createElement(NewCustomer, {
    onClick: () => doConsentInitAndPoll()
  }), (applicationDisplayStatus === displayStatus.BANKID_AUTH_QRCODE || applicationDisplayStatus === displayStatus.BANKID_DEBIT_QRCODE) && React.createElement(BankidQrcode, {
    isDeposit: applicationDisplayStatus === displayStatus.BANKID_DEBIT_QRCODE,
    onCancel: () => doClearBackend(),
    qrCode: qrCode
  }), (applicationDisplayStatus === displayStatus.BANKID_AUTH_WAIT || applicationDisplayStatus === displayStatus.BANKID_DEBIT_WAIT) && React.createElement(BankidQrcode, {
    isDeposit: applicationDisplayStatus === displayStatus.BANKID_DEBIT_QRCODE || applicationDisplayStatus === displayStatus.BANKID_DEBIT_WAIT,
    onCancel: () => doClearBackend(),
    qrCode: qrCode
  }), applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK_WAIT &&
  React.createElement(BankidSpinner, {
    isConsentSelectBankWait: applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK_WAIT,
    isDeposit: applicationDisplayStatus === displayStatus.BANKID_DEBIT_WAIT,
    onCancel: () => doClearBackend()
  }), (applicationDisplayStatus === displayStatus.BANKID_AUTH_APP || applicationDisplayStatus === displayStatus.BANKID_DEBIT_APP) && React.createElement(BankidApp, {
    isDeposit: applicationDisplayStatus === displayStatus.BANKID_DEBIT_AP,
    onCancel: () => doClearBackend()
  }), (applicationDisplayStatus === displayStatus.BANKID_AUTH_WAIT_APP || applicationDisplayStatus === displayStatus.BANKID_DEBIT_WAIT_APP || applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK_WAIT_APP) && React.createElement(BankidSpinner, {
    isConsentSelectBankWait: applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK_WAIT_APP,
    isDeposit: applicationDisplayStatus === displayStatus.BANKID_DEBIT_WAIT_APP,
    onCancel: () => doClearBackend()
  }), applicationDisplayStatus === displayStatus.SUCCESS && React.createElement(ExpressDeposit, {
    accountList: accountList,
    bankName: bankName,
    isPlayerRegistration: isPlayerRegistration,
    onClickChangeBank: () => getBankList(),
    onClickDeposit: depositData => doDepositInitAndPoll(depositData)
  }), applicationDisplayStatus === displayStatus.EXPIRED_TOKEN && React.createElement(ExpiredConsent, {
    onClick: () => doConsentInitAndPoll()
  }), (applicationDisplayStatus === displayStatus.CHANGE_BANK || applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK) && React.createElement(ChangeBank, {
    bankList: bankList,
    isConsentSelectBank: applicationDisplayStatus === displayStatus.CONSENT_SELECT_BANK,
    onClickChangeBank: _ref2 => {
      let {
        bankSubsidiaryId,
        isConsentSelectBank
      } = _ref2;
      return doConsentInitAndPoll({
        bankSubsidiaryId,
        isConsentSelectBank
      });
    },
    onClickReturn: () => getBankAccounts()
  })));
};
svs.accountservicesReact.deposit.swedbankExpress.SwedbankExpress = SwedbankExpress;

 })(window);